import { ActionCreator, AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import lbService from 'services/api/customer/lb-service';
import { RootState } from 'store';
import { ILB } from 'components/Loadbalancers/types';
import { ActionTypes } from './types/state.types';

export const setListOfLBs: ActionCreator<AnyAction> = (payload: ILB[]) => ({
  type: ActionTypes.SET_LIST,
  payload,
});

export type ThunkLBDispatch = ThunkDispatch<RootState, void, AnyAction>;

export const fetchVMList = () => async (dispatch: ThunkLBDispatch) => {
  const { data } = await lbService.getLBList();
  const LBs = data.data;
  dispatch(setListOfLBs(LBs));
  return LBs;
};
